import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { UploadService } from 'src/app/shared/services/uploads/upload.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SuccessEvent, UploadEvent, SelectEvent } from '@progress/kendo-angular-upload';
import { UploadFileData } from 'src/app/models/uploads';

@Component({
  selector: 'app-wage-file',
  templateUrl: './wage-file.component.html',
  styleUrls: ['./wage-file.component.css']
})
export class WageFileComponent implements OnInit {

  decimals = 2;
  maxRecordCount: any;
  maxAmount: any;
  editForm: UntypedFormGroup;
  config: any;
  allUploadIds = [];
  fileNameErrorMsg = '';
  msg = '';
  readonly uploadRemoveUrl: string = 'removeUrl';
  uploadSaveUrl: string;
  disableButton = true;

  constructor(
    private authService: AuthService,
    private uploadService: UploadService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    this.maxRecordCount = this.readConfigService.getMaxRecordCount();
    this.maxAmount = this.readConfigService.getMaxAmount();
    this.editForm = new UntypedFormGroup({
      fileType: new UntypedFormControl(''),
      recordCount: new UntypedFormControl('', [Validators.required, Validators.min(1), Validators.max(this.maxRecordCount)]),
      totalAmount: new UntypedFormControl('', [Validators.required, Validators.min(0.01), Validators.max(this.maxAmount)]),
      notes: new UntypedFormControl('')
    });
    this.config = this.readConfigService.getUploadFile();
    this.uploadSaveUrl = this.uploadService.getUploadUrl();
  }

  onAmountChange() {
    this.disableButton = (this.editForm && this.editForm.valid) ? false : true;
  }

  onCountChange() {
    this.disableButton = (this.editForm && this.editForm.valid) ? false : true;
  }

  uploadComplete(upload: any) {
    if (this.allUploadIds) {
      for (const allUploadId of this.allUploadIds) {
        upload.removeFilesByUid(allUploadId);
      }
      this.allUploadIds = [];
    }
  }

  uploadEventHandler(e: UploadEvent, ufile: any) {
    this.notificationService.setUpLoading(true);
    ufile.fileType = 'Wages';
    const files = e.files;
    for (const file of files) {
      const a = file.uid;
      if (a !== undefined) {
        this.allUploadIds.push(a);
      }
    }
    const data = new UploadFileData();
    data.fileType = ufile.fileType;
    data.notes = this.isNullOrUndefined(ufile.notes);
    data.recordCount = this.isNullOrUndefined(ufile.recordCount) === '' ? 0 : parseInt(ufile.recordCount, 0);
    data.totalAmount = this.isNullOrUndefined(ufile.totalAmount) === '' ? 0.00 : parseFloat(ufile.totalAmount.toFixed(2));
    if (this.authService !== null && this.authService.currentUser !== null) {
      data.userId = this.authService.currentUser.Id.toString();
    }
    data.userInfo = JSON.stringify(this.uploadService.UserInfo());
    e.data = data;
  }

  uploadSuccess(e: SuccessEvent) {
    const response = e.response;
    if (response && response.body) {
      this.disableButton = true;
      this.displayNotification(response.body);
    }
    this.notificationService.setUpLoading(false);
    this.reset();
  }

  selectEventHandler(e: SelectEvent) {
    const fileName = (e.files[0].name).substring(0, e.files[0].name.lastIndexOf('.') + 1);
    if (fileName.length > 200) {
      this.fileNameErrorMsg = this.config.MaxFileNameErrorMsg;
      this.displayNotification({ success: false, message: this.fileNameErrorMsg });
      e.preventDefault();
    }
  }

  errorEventHandler() {
    this.msg = this.config.ErrorMessage;
    this.displayNotification({ success: false, message: this.msg });
    this.notificationService.setUpLoading(false);
  }

  displayNotification(response: any) {
    this.notificationService.setUpNotification(response);
  }

  reset() {
    this.editForm.reset();
  }

  isNullOrUndefined(args: any) {
    return args === undefined || args === null ? '' : args;
  }
}
